import { render } from "./ValidateUserTwoFactor.vue?vue&type=template&id=1617458b&ts=true"
import script from "./ValidateUserTwoFactor.vue?vue&type=script&lang=ts"
export * from "./ValidateUserTwoFactor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__